<template>
    <v-row class="card-container">
        <v-col cols="4" class="p-relative">
            <v-img contain :src="require('@/assets/img/hand-card.png')" class="card-img"/>
        </v-col>
        <v-col cols="8" v-if="currentPlan">
            <div class="card-text">
                {{ currentPlan.amount }} {{ currentPlan.currency }} {{ currentPlan.interval.toLowerCase() }}
            </div>
            <div class="card-text-primary my-1">
                {{ currentPlan.name }}
            </div>
            <div class="card-subtext">
                {{ currentPlan.description }}
            </div>
        </v-col>
        <v-col cols="8" v-else>
            <div class="card-text my-1">
                {{ $t('payment.plan_not_found') }}
            </div>
            <div class="card-subtext">
                {{ $t('payment.contact_support') }}
            </div>
        </v-col>
    </v-row>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name: "CurrentSubscription",
    computed: {
        ...mapState(['plans']),
        currentPlan(vm = this) {
            if (vm.plans.length === 0) return null
            let priceId = vm.account?.stripeAccount?.currentSubscription?.priceId || null
            return vm.plans.find(plan => plan.priceId === priceId)
        }
    },
    async mounted() {
        const vm = this
        await vm.loadPlans()
    },
    methods: {
        ...mapActions(['bindPlans', 'bindCompanyPlans']),
        async loadPlans() {
            const vm = this
            if (vm.plans.length === 0 && vm.account.accountType) {
                vm.account.accountType === 'company' ?
                    await vm.bindCompanyPlans() :
                    await vm.bindPlans()
            }
        }
    },
    watch: {
        account() {
            this.loadPlans()
        }
    }
}
</script>

<style scoped>

.card-container {
    background-color: #CCFF99;
    border-radius: 20px;
}

.card-img {
    position: absolute;
    bottom: 0;
    left: 0;
    top: 0;
    right: 0;
}

.card-text {
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #161616;
}

.card-text-primary {
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #161616;
    text-transform: uppercase;
}

.card-subtext {
    font-size: 16px;
    line-height: 19px;
    color: #161616;
}

</style>